import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { AvatarWithMessageComponent } from '@shared/avatar-with-message/avatar-with-message.component';
import { AvatarWithMessageItem } from '@shared/avatar-with-message/avatar-with-message.types';
import {
    AvatarSubtitle,
    AvatarTitle,
    AvatarSmile,
    RotatePosition,
} from '@shared/avatar-with-message/avatar-with-message.constants';

@Component({
    selector: 'companyid-avatar',
    imports: [AvatarWithMessageComponent],
    templateUrl: './avatar.component.html',
    styleUrl: './avatar.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
    public readonly avatars: AvatarWithMessageItem[] = [
        {
            classNames: 'left-[295px] -top-[20px] tab:left-[245px]',
            position: RotatePosition.TWO_DEG,
            avatarImg: 'old-man',
            title: AvatarTitle.I_AM_A,
            subtitle: AvatarSubtitle.DEVELOPER,
            smile: AvatarSmile.SMART,
        },
        {
            classNames: 'left-[520px] bottom-[352px] tab:top-[330px] tab:left-[calc(100vw-205px)]',
            position: RotatePosition.FIVE_DEG,
            avatarImg: 'girl',
            title: AvatarTitle.HI_I_AM_A,
            subtitle: AvatarSubtitle.CEO,
            smile: AvatarSmile.CHILL,
        },
        {
            classNames: 'left-[535px] top-[368px] tab:top-[20px] tab:left-[calc(100vw-310px)]',
            position: RotatePosition.EIGHT_DEG,
            avatarImg: 'woman',
            title: AvatarTitle.HI_I_AM_AN,
            subtitle: AvatarSubtitle.ACCOUNTANT,
            smile: AvatarSmile.WINKY,
        },
        {
            classNames: 'left-[940px] bottom-[400px] tab:left-[calc(100vw-405px)] tab:top-[210px]',
            position: RotatePosition.ZERO_DEG,
            avatarImg: 'man',
            title: AvatarTitle.YO_I_AM_AN,
            subtitle: AvatarSubtitle.SMM,
            smile: AvatarSmile.STAR,
        },
    ];
}
